import type { Partner } from '@/types';

export const mockPartners: Partner[] = [
  {
    id: 'partner-001',
    legal_name: 'Van Dijk Advocaten B.V.',
    display_name: 'Van Dijk Legal',
    country: 'NL',
    vat_id: 'NL823456789B01',
    billing_currency: 'EUR',
    primary_contact_name: 'Sam van Dijk',
    primary_email: 'sam@vandijklegal.nl',
    primary_phone: '+31 20 123 4567',
    whatsapp_phone: '+31 6 12345678',
    preferred_language: 'nl',
    status: 'active',
    partner_tier: 'preferred',
    reliability_score: 0.9234,
    internal_notes: 'Top performing legal partner in Amsterdam. High conversion rate on personal injury leads.',
    created_at: '2024-01-15T00:00:00Z',
    archived_at: null
  },
  {
    id: 'partner-002',
    legal_name: 'Goldman Realty LLC',
    display_name: 'Goldman Realty',
    country: 'US',
    vat_id: null,
    billing_currency: 'USD',
    primary_contact_name: 'Michael Goldman',
    primary_email: 'mike@goldmanrealty.com',
    primary_phone: '+1 212 555 0199',
    whatsapp_phone: null,
    preferred_language: 'en',
    status: 'active',
    partner_tier: 'strategic',
    reliability_score: 0.8912,
    internal_notes: 'Major NYC real estate brokerage. Prefers buyer leads above $400k.',
    created_at: '2024-02-01T00:00:00Z',
    archived_at: null
  },
  {
    id: 'partner-003',
    legal_name: 'PVC Vloer Nederland B.V.',
    display_name: 'PVC Vloer Nederland',
    country: 'NL',
    vat_id: 'NL987654321B01',
    billing_currency: 'EUR',
    primary_contact_name: 'Mark de Vries',
    primary_email: 'info@pvcvloer.nl',
    primary_phone: '+31 20 987 6543',
    whatsapp_phone: '+31 6 98765432',
    preferred_language: 'nl',
    status: 'active',
    partner_tier: 'standard',
    reliability_score: 0.8567,
    internal_notes: 'PVC and laminate flooring specialist serving Amsterdam and surrounding region. High conversion on premium click PVC leads. 4,200+ installations completed.',
    created_at: '2024-03-01T00:00:00Z',
    archived_at: null
  },
  {
    id: 'partner-004',
    legal_name: 'Fysio Amsterdam Zuid B.V.',
    display_name: 'Fysio Amsterdam Zuid',
    country: 'NL',
    vat_id: 'NL123987654B01',
    billing_currency: 'EUR',
    primary_contact_name: 'Dr. Lisa de Vries',
    primary_email: 'admin@fysioamsterdam.nl',
    primary_phone: '+31 20 456 7890',
    whatsapp_phone: null,
    preferred_language: 'nl',
    status: 'active',
    partner_tier: 'standard',
    reliability_score: 0.8123,
    internal_notes: 'Physiotherapy clinic in Amsterdam Zuid. Accepts insured and uninsured patients.',
    created_at: '2024-03-15T00:00:00Z',
    archived_at: null
  },
  {
    id: 'partner-005',
    legal_name: 'First Capital Lending Inc.',
    display_name: 'First Capital Lending',
    country: 'US',
    vat_id: null,
    billing_currency: 'USD',
    primary_contact_name: 'James Rodriguez',
    primary_email: 'james@firstcapitallending.com',
    primary_phone: '+1 415 555 0123',
    whatsapp_phone: null,
    preferred_language: 'en',
    status: 'active',
    partner_tier: 'preferred',
    reliability_score: 0.6789,
    internal_notes: 'Mortgage and home equity lender. Prefers leads with good+ credit scores.',
    created_at: '2024-04-01T00:00:00Z',
    archived_at: null
  },
  {
    id: 'partner-006',
    legal_name: 'Texas Personal Injury Law Firm PLLC',
    display_name: 'Texas PI Law Firm',
    country: 'US',
    vat_id: null,
    billing_currency: 'USD',
    primary_contact_name: 'Robert Martinez',
    primary_email: 'robert@txpifirm.com',
    primary_phone: '+1 713 555 0456',
    whatsapp_phone: null,
    preferred_language: 'en',
    status: 'active',
    partner_tier: 'standard',
    reliability_score: 0.8234,
    internal_notes: 'Personal injury firm in Houston. High case values, selective on severity.',
    created_at: '2024-04-15T00:00:00Z',
    archived_at: null
  }
];